import BillingChart from "./BillingChart";
import OutstandingAndAging from "./OutstandingAndAging";
import RevenueAndPayment from "./RevenueAndPayment";
import RevenueReport from "./RevenueReport";
import SummaryCards from "./SummaryCards";

function Main() {
  return (
    <div className="App">
      <div style={{ padding: "30px", background: "#f8f9fb" }}>
        <SummaryCards />
      </div>

      <div style={{ padding: "0px", background: "#f9fafc" }}>
        <RevenueReport />
      </div>
      <div style={{ padding: "0px", background: "#f9fafc" }}>
      <OutstandingAndAging />
      </div>
      

      <RevenueAndPayment />
      <div style={{ padding: "30px 0px", background: "#f9fafc" }}>
        <BillingChart />
      </div>
    </div>
  );
}

export default Main;
